import api from "@/services/api"
import type { Pagination } from "@/types/pagination"
import type {
  AdversaryGet,
  AdversaryId,
  AdversaryPost,
  AdversaryValidate
} from "@/types/adversaries"
import { ListResource } from "@/utils/ListResource"

export class AdversaryApi extends ListResource {
  public getAllAdversaries = (
    page: number,
    search = "",
    per_page = 12,
    order = ""
  ) => {
    this.setPage(page)
    this.setPerPage(per_page)
    this.setSearch(search)
    this.setOrder(order)

    const filterString = this.search ? `?filter=${this.search}` : ""
    const sortString = this.order_by
      ? this.search
        ? `&sort=${this.order_by}`
        : `?sort=${this.order_by}`
      : ""

    return api.get<Pagination<AdversaryGet>>(
      `/api/v1/adversaries${filterString}${sortString}`,
      {
        params: {
          page: this.page,
          page_size: this.per_page
        }
      }
    )
  }

  public getAdversary = (id: AdversaryId) =>
    api.get<AdversaryGet>("/api/v1/adversary/" + id)

  public createAdversary = (data: AdversaryPost) =>
    api.post("/api/v1/adversary", data)

  public validateAdversary = (data: AdversaryPost) =>
    api.post<AdversaryValidate>("/api/v1/validate_adversary", data)

  public updateAdversary = (id: AdversaryId, data: AdversaryPost) =>
    api.put("/api/v1/adversary/" + id, data)

  public deleteAdversary = (id: AdversaryId) =>
    api.delete(`/api/v1/delete_adversary/${id}`)
}
